import R from "./r_all_components/R.jsx";
import R_And_Or from "./r_all_components/R_And_Or.jsx";
import R_Arrays from "./r_all_components/R_Arrays.jsx";
import R_Bars from "./r_all_components/R_Bars.jsx";
import R_Booleans from "./r_all_components/R_Booleans.jsx";
import R_Certificate from "./r_all_components/R_Certificate.jsx";
import R_Comments from "./r_all_components/R_Comments.jsx";
import R_Compiler from "./r_all_components/R_Compiler.jsx";
import R_Concatenate_Elements from "./r_all_components/R_Concatenate_Elements.jsx";
import R_DataFrames from "./r_all_components/R_DataFrames.jsx";
import R_DataSet from "./r_all_components/R_DataSet.jsx";
import R_DataStructures from "./r_all_components/R_DataStructures.jsx";
import R_DataTypes from "./r_all_components/R_DataTypes.jsx";
import R_Escape_Characters from "./r_all_components/R_Escape_Characters.jsx";
import R_Examples from "./r_all_components/R_Examples.jsx";
import R_Exercises from "./r_all_components/R_Exercises.jsx";
import R_Factors from "./r_all_components/R_Factors.jsx";
import R_ForLoop from "./r_all_components/R_ForLoop.jsx";
import R_Functions from "./r_all_components/R_Functions.jsx";
import R_GetStarted from "./r_all_components/R_GetStarted.jsx";
import R_Global_Variables from "./r_all_components/R_Global_Variables.jsx";
import R_HOME from "./r_all_components/R_HOME.jsx";
import R_IfElse from "./r_all_components/R_IfElse.jsx";
import R_Intro from "./r_all_components/R_Intro.jsx";
import R_Line from "./r_all_components/R_Line.jsx";
import R_Lists from "./r_all_components/R_Lists.jsx";
import R_Math from "./r_all_components/R_Math.jsx";
import R_Matrices from "./r_all_components/R_Matrices.jsx";
import R_MaxMin from "./r_all_components/R_MaxMin.jsx";
import R_MeanMedianMode from "./r_all_components/R_MeanMedianMode.jsx";
import R_Median from "./r_all_components/R_Median.jsx";
import R_Mode from "./r_all_components/R_Mode.jsx";
import R_Multiple_Variables from "./r_all_components/R_Multiple_Variables.jsx";
import R_Nested_Functions from "./r_all_components/R_Nested_Functions.jsx";
import R_Nested_If from "./r_all_components/R_Nested_If.jsx";
import R_Nested_Loop from "./r_all_components/R_Nested_Loop.jsx";
import R_Numbers from "./r_all_components/R_Numbers.jsx";
import R_Operators from "./r_all_components/R_Operators.jsx";
import R_Percentiles from "./r_all_components/R_Percentiles.jsx";
import R_PieCharts from "./r_all_components/R_PieCharts.jsx";
import R_Plot from "./r_all_components/R_Plot.jsx";
import R_Quiz from "./r_all_components/R_Quiz.jsx";
import R_Recursion from "./r_all_components/R_Recursion.jsx";
import R_Scatterplot from "./r_all_components/R_Scatterplot.jsx";
import R_StatisticsIntro from "./r_all_components/R_StatisticsIntro.jsx";
import R_Strings from "./r_all_components/R_Strings.jsx";
import R_StudyPlan from "./r_all_components/R_StudyPlan.jsx";
import R_Syllabus from "./r_all_components/R_Syllabus.jsx";
import R_Syntax from "./r_all_components/R_Syntax.jsx";
import R_Syntax_Print from "./r_all_components/R_Syntax_Print.jsx";
import R_Variables from "./r_all_components/R_Variables.jsx";
import R_Variable_Names from "./r_all_components/R_Variable_Names.jsx";
import R_Vectors from "./r_all_components/R_Vectors.jsx";
import R_WhileLoop from "./r_all_components/R_WhileLoop.jsx";

const AllRComponents = {
  "<R />": R,
  "<R_And_Or />": R_And_Or,
  "<R_Arrays />": R_Arrays,
  "<R_Bars />": R_Bars,
  "<R_Booleans />": R_Booleans,
  "<R_Certificate />": R_Certificate,
  "<R_Comments />": R_Comments,
  "<R_Compiler />": R_Compiler,
  "<R_Concatenate_Elements />": R_Concatenate_Elements,
  "<R_DataFrames />": R_DataFrames,
  "<R_DataSet />": R_DataSet,
  "<R_DataStructures />": R_DataStructures,
  "<R_DataTypes />": R_DataTypes,
  "<R_Escape_Characters />": R_Escape_Characters,
  "<R_Examples />": R_Examples,
  "<R_Exercises />": R_Exercises,
  "<R_Factors />": R_Factors,
  "<R_ForLoop />": R_ForLoop,
  "<R_Functions />": R_Functions,
  "<R_GetStarted />": R_GetStarted,
  "<R_Global_Variables />": R_Global_Variables,
  "<R_HOME />": R_HOME,
  "<R_IfElse />": R_IfElse,
  "<R_Intro />": R_Intro,
  "<R_Line />": R_Line,
  "<R_Lists />": R_Lists,
  "<R_Math />": R_Math,
  "<R_Matrices />": R_Matrices,
  "<R_MaxMin />": R_MaxMin,
  "<R_MeanMedianMode />": R_MeanMedianMode,
  "<R_Median />": R_Median,
  "<R_Mode />": R_Mode,
  "<R_Multiple_Variables />": R_Multiple_Variables,
  "<R_Nested_Functions />": R_Nested_Functions,
  "<R_Nested_If />": R_Nested_If,
  "<R_Nested_Loop />": R_Nested_Loop,
  "<R_Numbers />": R_Numbers,
  "<R_Operators />": R_Operators,
  "<R_Percentiles />": R_Percentiles,
  "<R_PieCharts />": R_PieCharts,
  "<R_Plot />": R_Plot,
  "<R_Quiz />": R_Quiz,
  "<R_Recursion />": R_Recursion,
  "<R_Scatterplot />": R_Scatterplot,
  "<R_StatisticsIntro />": R_StatisticsIntro,
  "<R_Strings />": R_Strings,
  "<R_StudyPlan />": R_StudyPlan,
  "<R_Syllabus />": R_Syllabus,
  "<R_Syntax />": R_Syntax,
  "<R_Syntax_Print />": R_Syntax_Print,
  "<R_Variables />": R_Variables,
  "<R_Variable_Names />": R_Variable_Names,
  "<R_Vectors />": R_Vectors,
  "<R_WhileLoop />": R_WhileLoop,
};

export default AllRComponents;
